import React from "react";
import { formAColumn } from "app/_pages/UserManagement/FormA/FormA.data";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import { TRAINEE_TYPE } from "../TrainingManagement/CONSTANTS";
import { employeeEmploymentStatusObj } from "app/_pages/UserManagement/Employee/Constant";
import { capitalizeName } from "app/_helpers/helper";

export const formAManagementColumns = [
  {
    dataField: "sid",
    text: "S.No.",
  },
  {
    dataField: "siteName",
    text: "Location",
  },
  {
    dataField: "staffTypeName",
    text: "Staff Type",
  },
  {
    dataField: "employeeId",
    text: "Emp ID",
  },
  {
    dataField: "fullName",
    text: "Name",
    formatter: (date, row) => {
      return <div>{capitalizeName(row?.fullName)}</div>;
    },
  },
  {
    dataField: "dob",
    text: "DOB",
    formatter: (date, row) => (row?.dob ? DDMMYYYYFormat(row?.dob) : row?.dob),
  },
  {
    dataField: "employmentStatus",
    text: "Employment Status",
  },
  {
    dataField: "formA",
    text: " Form A",
    // formatter: (date, row) => {
    //   return <div>{row?.employeeFormA?.serialNumberOmc}</div>;
    // },
  },
  {
    dataField: "formAStatus",
    text: "Form A Status",
    formatter: (value) => (
      <div
        className={`font-weight-bold text-${
          value === "Completed" ? "success" : "warning"
        }`}
      >
        {value}
      </div>
    ),
  },
  {
    ...formAColumn(true),
    text: "Action",
  },
];

export const formAFilterFields = [
  {
    name: "currentWorkLocation",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "staffTypeName",
    title: "Staff Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys({ all: "All", ...TRAINEE_TYPE }).map((key) => ({
      label: { all: "All", ...TRAINEE_TYPE }[key],
      value: { all: "All", ...TRAINEE_TYPE }[key],
    })),
  },
  {
    name: "employmentStatus",
    title: "Employment Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(employeeEmploymentStatusObj).map((k) => ({
      label: employeeEmploymentStatusObj[k],
      value: k,
    })),
  },
  {
    name: "dob",
    title: "DOB",
    inputType: EFormFieldInputTypes.date,
  },
  {
    name: "id",
    title: "Name",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "contractorId",
    title: "Contractor",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "aadharNumber",
    title: "Aadhar",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "panNo",
    title: "PAN",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "uanNo",
    title: "UAN",
    inputType: EFormFieldInputTypes.text,
  },
];
